import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Slider } from '../../../common/knobs';
import { Button } from '../../../common/buttons';
import { Icon } from '../../../common/layout';
import { getZoom, zoomTo } from '../../../interface';

import './ZoomControl.scss';

const ZoomControl = ({ zoom }) => {
  const [showSlider, setShowSlider] = useState(false);

  const setZoom = ({ fullZoom, increment }) => {
    const currentZoom = getZoom();
    const desiredZoom = fullZoom ?? currentZoom + increment;
    zoomTo(desiredZoom);
  };

  const renderZoomTooltip = (text) => (
    <>
      <p>{text}</p>
      <Button
        className="text-btn white"
        handleClick={() => setShowSlider(!showSlider)}
      >
        {!showSlider ? 'Show Slider' : 'Hide Slider'}
      </Button>
    </>
  );

  return (
    <div className="map-controls__zoom-btn-wrapper">
      <Button
        className="map-controls__zoom-in-btn map-btn"
        handleClick={() => setZoom({ increment: 1 })}
        aria-label="Zoom In"
        toolTipId="zoom-in-btn"
        renderToolTip={() => renderZoomTooltip('Zoom In')}
        toolTipOptions={{
          clickable: true,
          className: 'hover-tooltip',
          delayHide: 200,
        }}
      >
        <Icon iconName="add" />
      </Button>
      {showSlider && (
        <div className="map-controls__slider-wrapper">
          <Slider
            vertical
            value={zoom || 17}
            changeHandler={(val) => setZoom({ fullZoom: val })}
            min={0}
            max={22}
            step={1}
          />
        </div>
      )}
      <Button
        className="map-controls__zoom-out-btn map-btn"
        handleClick={() => setZoom({ increment: -1 })}
        aria-label="Zoom Out"
        toolTipId="zoom-out-btn"
        renderToolTip={() => renderZoomTooltip('Zoom Out')}
        toolTipOptions={{
          clickable: true,
          className: 'hover-tooltip',
          delayHide: 200,
        }}
      >
        <Icon iconName="remove" />
      </Button>
    </div>
  );
};

ZoomControl.propTypes = {
  zoom: PropTypes.number,
};

export default ZoomControl;
